import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PolarisFormProvider from '@container/PolarisFormProvider';
import SettingsForm from '@presentational/shop/SettingsForm';

const propTypes = {
  submitURL: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,

  shopifyHooks: PropTypes.shape({
    submitURL: PropTypes.string.isRequired,
    webhooks: PropTypes.array.isRequired,
  }).isRequired,
};

const defaultProps = {

}


const SettingsContainer = (props) => (
  <PolarisFormProvider
    title={ I18n.t("app.shop.settings_screen") }
    defaultValues={ props.values }

    submitURL={ props.submitURL }
    submitMethod={ "POST" }
    paramsName="shop"
    pageProps={{
      breadcrumbs: [{content: I18n.t("actions.back"), url: '/'}]
    }}
  >
    { (renderProps) => 
      <SettingsForm
        locations={ props.locations }
        shopifyHooks={ props.shopifyHooks }
        {...renderProps}
      />
    }
  </PolarisFormProvider>
)

SettingsContainer.propTypes = propTypes;
SettingsContainer.defaultProps = defaultProps;

export default SettingsContainer;